import { HttpEvent, HttpEventType, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { LoggerService } from '../shared/logger.service';

export function loggingInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const logger = inject(LoggerService);

  logger.debug(`Call to: ${req.method}: ${req.url}`);
  return next(req).pipe(tap(event => {
    if (event.type === HttpEventType.Response) {
      logger.debug(`${req.url} returned a response with status: ${event.status}`)
      // console.log(req.url, 'returned a response with status', event.status);
    }
  }));
}
